module.exports = "https://redage.akamaized.net/src/views/player/hudevo/phonenew/assets/images/messages.png";